/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_PhraseInputs */

const en_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const fr_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const de_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const it_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

const ru_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фраза`)
};

const es_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

const zh_cn2_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短语`)
};

const ja_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーズ`)
};

const hi_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वाक्यांश`)
};

const pt_pt2_knp_terms_type_phrase = /** @type {(inputs: Knp_Terms_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

/**
* | output |
* | --- |
* | "Phrase" |
*
* @param {Knp_Terms_Type_PhraseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_phrase = /** @type {((inputs?: Knp_Terms_Type_PhraseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_PhraseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_type_phrase(inputs)
	if (locale === "de") return de_knp_terms_type_phrase(inputs)
	if (locale === "it") return it_knp_terms_type_phrase(inputs)
	if (locale === "ru") return ru_knp_terms_type_phrase(inputs)
	if (locale === "es") return es_knp_terms_type_phrase(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_type_phrase(inputs)
	if (locale === "ja") return ja_knp_terms_type_phrase(inputs)
	if (locale === "hi") return hi_knp_terms_type_phrase(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_type_phrase(inputs)
	return en_knp_terms_type_phrase(inputs)
});